'use client'

/* eslint-disable no-unneeded-ternary */
/* eslint-disable import/no-extraneous-dependencies */

import styled from 'styled-components'
import Image from 'next/image'

import { type CompanyAddressPropsT } from '.'

export const CAWrapper = styled.div<Pick<CompanyAddressPropsT, 'margin'>>`
  ${(props) => props.margin && `margin: ${props.margin}`}
`

export const Address = styled.div`
  font-size: 12px;
  line-height: 18px;
  color: #414a53;
  width: 265px;
  margin: 20px 0 0 0;
`

export const CAADNewLogo = styled(Image)`
  object-fit: scale-down;
`
